export default __webpack_public_path__ + "static/media/HostingCloudLandingPage.6b09b2aa.jpeg";